import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Button, Copy } from '@elparking/components'
import { FormattedMessage } from 'react-intl'

import VehicleInspectionProductsList from 'vehicle-inspection-product-selector/js/components/VehicleInspectionProductsList'

function VehicleInspectionProductsModalContent ({products, onClick, onSubmit, selectedProduct}) {
    return (
        <Flex flexWrap='wrap' p='2em 0'>
            <Box w='100%' mb='1.5em' px='0'>
                <Copy padding='0 0 4px 0' size='xxLarge' fontWeight='book' color='gray'>
                    <FormattedMessage
                      defaultMessage='Tarifas'
                    />
                </Copy>
                <Copy padding='0' size='small' fontWeight='regular' color='gray60'>
                    <FormattedMessage
                      defaultMessage='Elige la tarifa que mejor se adapta a ti'
                    />
                </Copy>
            </Box>
            <Box w='100%' mb='1em'>
                <VehicleInspectionProductsList
                  products={products}
                  onClick={onClick}
                  selectedProduct={selectedProduct}
                />
            </Box>
            <Box w='100%'>
                <Button
                  width='100%'
                  onClick={onSubmit}
                >
                    <Copy as='span' padding='0' fontWeight='medium' size='medium' color='white'>
                        <FormattedMessage
                          defaultMessage='Seleccionar'
                        />
                    </Copy>
                </Button>
            </Box>
        </Flex>
    )
}

VehicleInspectionProductsModalContent.defaultProps = {
    onSubmit: () => {},
}

VehicleInspectionProductsModalContent.propTypes = {
    selectedProduct: PropTypes.object,
    products: PropTypes.array,
    onSubmit: PropTypes.func,
    onClick: PropTypes.func,
}

export default VehicleInspectionProductsModalContent
